<template>
  <div>
    <section class="mt-3">
      <b-field>
        <b-switch v-model="disponible" class="ml-3" @input="cambiarEstado">
          <span>{{ nombreEstado }}</span>
        </b-switch>
      </b-field>
    </section>
    <div v-if="mostrarFormulario">
      <section v-if="!tiempoSeleccionado && tiempo !== -1" class="mt-3">
        <b-field grouped group-multiline>
          <b-radio-button
            v-for="(item, index) in tiempos"
            :key="`radio-${index}`"
            v-model="tiempo"
            :native-value="item"
            type="is-info"
            @input="confirmarFecha"
          >
            <b-icon icon="clock" />
            <span>{{ item }} Min</span>
          </b-radio-button>
          <b-radio-button v-model="tiempo" :native-value="-1" type="is-info">
            <b-icon icon="calendar-alt" />
            <span>Ingresar...</span>
          </b-radio-button>
        </b-field>
      </section>
      <section v-if="tiempo === -1 && !tiempoSeleccionado" class="mt-3">
        <b-field label="Seleccione término">
          <b-datetimepicker
            v-model="fechaHasta"
            append-to-body
            placeholder="Haga clic para seleccionar..."
            icon="calendar-alt"
            :min-datetime="new Date()"
            :datepicker="datepicker"
            :timepicker="timepicker"
          />
          <div class="pl-2">
            <b-button type="is-info" @click="confirmarFecha">
              <b-icon icon="check" />
              <span>Confirmar</span>
            </b-button>
          </div>
        </b-field>
      </section>
      <section v-if="tiempoSeleccionado" class="mt-3">
        <span><strong>Hasta: </strong>{{ intervaloTiempo }}</span>
        <span class="ml-3" />
        <b-button
          type="is-info"
          size="is-small"
          icon-left="pencil-alt"
          @click="modificarTiempo"
        >
          Cambiar
        </b-button>
      </section>
      <section v-if="tiempoSeleccionado && motivo === 0" class="mt-3">
        <div v-for="item in motivos" :key="`motivo-${item.id}`" class="field">
          <b-radio v-model="motivo" :native-value="item.id * 1">
            {{ item.nombre }}
          </b-radio>
        </div>
      </section>
      <section v-if="motivo > 0" class="mt-3">
        <span><strong>Motivo: </strong>{{ nombreMotivo }}</span>
        <span class="ml-3" />
        <b-button
          type="is-info"
          size="is-small"
          icon-left="pencil-alt"
          @click="modificarMotivo"
        >
          Cambiar
        </b-button>
      </section>
      <section v-if="motivo > 0" class="mt-3">
        <b-button
          type="is-info"
          icon-left="check"
          @click="confirmarDisponibilidad"
        >
          Ingresar
        </b-button>
      </section>
    </div>
  </div>
</template>

<script>
import { addMinutes, formatDistanceToNow } from 'date-fns'
import { es } from 'date-fns/locale'

import { motivoService } from '@/services'

export default {
  name: 'CambioEstado',
  props: {
    usuario: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      disponible: false,
      tiempo: 0,
      motivo: 0,
      tiempoSeleccionado: false,
      fechaHasta: new Date(),
      tiempos: [1, 5, 10, 15, 30],
      motivos: [],
      usuarioWatcher: null,
      timepicker: {
        incrementMinutes: 5
      },
      datepicker: {
        'first-day-of-week': 1,
        'month-names': [
          'Enero',
          'Febrero',
          'Marzo',
          'Abril',
          'Mayo',
          'Junio',
          'Julio',
          'Agosto',
          'Septiembre',
          'Octubre',
          'Noviembre',
          'Diciembre'
        ],
        'day-names': ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá'],
        position: 'is-bottom-left'
      }
    }
  },
  computed: {
    intervaloTiempo() {
      return formatDistanceToNow(this.getFechaHasta(), {
        locale: es,
        addSuffix: true
      })
    },
    mostrarFormulario() {
      return this.usuario.estaDisponible !== this.disponible
    },
    nombreEstado() {
      return this.disponible ? 'Disponible' : 'No disponible'
    },
    nombreMotivo() {
      const seleccionado = this.motivo
      const motivo = this.motivos.find((item) => item.id === seleccionado)
      return motivo.nombre || ''
    }
  },
  watch: {
    usuario() {
      this.disponible = this.usuario.estaDisponible
      this.cambiarEstado()
    }
  },
  mounted() {
    this.disponible = this.usuario.estaDisponible
    this.$nextTick(() => this.getMotivos())
  },
  methods: {
    cambiarEstado() {
      this.tiempoSeleccionado = false
      this.motivo = 0
      this.tiempo = 0
      this.fechaHasta = new Date()
    },
    confirmarDisponibilidad() {
      const objeto = {
        usuarioId: this.usuario.id,
        motivoId: this.motivo,
        descripcion: this.nombreMotivo,
        estaOperativo: this.disponible,
        inicio: this.formatearZonaHoraria(new Date()),
        termino: this.formatearZonaHoraria(this.getFechaHasta())
      }
      this.$emit('cambiar-estado', objeto)
    },
    confirmarFecha() {
      this.tiempoSeleccionado = true
    },
    getFechaHasta() {
      if (this.tiempo === -1) {
        return this.fechaHasta
      }
      return addMinutes(new Date(), this.tiempo)
    },
    getMotivos() {
      motivoService
        .getMotivos()
        .then((response) => (this.motivos = response.data))
        .catch((error) => this.procesarError(error))
    },
    modificarTiempo() {
      this.tiempoSeleccionado = false
      this.tiempo = 0
      this.motivo = 0
    },
    modificarMotivo() {
      this.motivo = 0
    }
  }
}
</script>
